import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface Cuisines {
    cuisineTypeId: any;
    dietTypeName: any;
    id: number;
    cuisineTypeName: any;
    imageUrl: any;
    isActive: boolean
}

interface AllergenceState {
    data: Cuisines[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

interface ApiResponse {
    data: Cuisines[];
}

export const fetchCuisines = createAsyncThunk<Cuisines[], void, { rejectValue: string }>(
    'cuisines/fetchCuisines',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<ApiResponse>('/get_all_cuisine_type', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const createCuisines: any = createAsyncThunk(
    'cuisines/createCuisines', async (params: any, thunkAPI) => {
        console.log(params)
        try {
            const response = await apiService.post('create_cuisine_type', params, PORT, MASTERURL);
            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const deleteCuisine: any = createAsyncThunk<
    number,                 // ✅ return type: deleted id
    number         // ✅ argument type: cuisine id
>(
    "cuisines/deleteCuisine",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `soft_delete_cuisine_type?id=${id}`,
                {},
                PORT,
                MASTERURL
            );
            return response



        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);


export const updateCuisines: any = createAsyncThunk(
    'cuisines/updateCuisines',
    async (params: any, thunkAPI) => {
        console.log(params)
        try {
            const response = await apiService.put('update_cuisine_type', params, PORT, MASTERURL);
            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);
export const cuisinesSlice = createSlice({
    name: 'cuisines',
    initialState: {
        data: [] as Cuisines[],
        loading: false,
        error: null,
    } as AllergenceState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCuisines.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCuisines.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCuisines.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createCuisines.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCuisines.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(createCuisines.rejected, (state, action: PayloadAction<string>) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateCuisines.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCuisines.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                const updatedTable = action.payload;
            })
            .addCase(updateCuisines.rejected, (state, action: PayloadAction<string>) => {
                state.loading = false;
                state.error = action.payload;
            })

    },
});

export default cuisinesSlice.reducer;